import { createRouter, createWebHistory } from 'vue-router'
// import HomeView from '../views/HomeView.vue'
import LoginPage from '@/components/LoginPage.vue'
import DashboardView from '@/views/DashboardView.vue'
const routes = [
  {
    path: '/',
    name: 'login',
    component: LoginPage
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: DashboardView
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})



router.beforeEach((to, from, next) => {
  const isLoggedIn = !!localStorage.getItem('token'); // Check if the user is logged in

  // Redirect to the dashboard if trying to access the login page when logged in
  if (to.name === 'login' && isLoggedIn) {
    next({ name: 'dashboard' });
  } else if (to.name !== 'login' && !isLoggedIn) {
    // Redirect to the login page if trying to access any other page when not logged in
    next({ name: 'login' });
  } else {
    // Allow access
    next();
  }
});

export default router
